/*
  HOW TO USE:
    Create <parallax-element> and add desired attributes

    Animations are configured by setting the desired start and end values for a
    particular setting and selecting when during the scrolling of the element
    within the window you would like the animation to start and stop.

    Animation configuration attributes (all are optional):
      - data-animation - Configure the start and stop points of the animation
      - data-translate-y - Perform a Y-axis translation (enabled with "tw-transform" class)
      - data-opacity - Transition between opacity settings (enabled with "tw-variable-opacity" class)
      - data-scale - Perform a scale transform (enabled with "tw-transform" class)

    The value of each attribute is expected to be a two-tuple separated by a
    comma for the FROM and TO animation values.

    IMPORTANT: If you do not specify the appropriate class on the element the
    animations will not be enabled. For example, for any transforms you need to add
    the `tw-transform`.

    Responsiveness: You can use Tailwind responsive selectors to enable /
    disable animations for different breakpoints

    Example: <parallax-element data-opacity="1,0"> will fade out the element
    through the animation window (start at full opacity and fade to none)
*/
if (!customElements.get('parallax-element')) {
  customElements.define('parallax-element',
    class ParallaxElement extends HTMLElement {
      parallaxProps = {}

      constructor() {
        super();

        this.classList.add('tw-duration-100','tw-linear')

        // y translation
        if(this.dataset.translateY) {
          this.style.setProperty('--tw-translate-y','var(--y)')
          this.parallaxProps['--y'] = this.parseFromToPair(this.dataset.translateY)
        }

        // opacity
        if(this.dataset.opacity) {
          this.style.setProperty('--tw-opacity','var(--opacity)')
          this.parallaxProps['--opacity'] = this.parseFromToPair(this.dataset.opacity)
        }

        // scale
        if(this.dataset.scale) {
          this.style.setProperty('--tw-scale-x','var(--scale)')
          this.style.setProperty('--tw-scale-y','var(--scale)')
          this.parallaxProps['--scale'] = this.parseFromToPair(this.dataset.scale)
        }

        this.start = this.start.bind(this)
        this.start()
      }

      start() {
        const defaultAnimationWindow = { from: 'top-bottom', to: 'bottom-top' }

        // Ref: https://github.com/electerious/basicScroll
        const instance = basicScroll.create({
          ...this.parseFromToPair(this.dataset.animation, { defaults: defaultAnimationWindow }),
          elem: this,
          direct: true,
          props: this.parallaxProps
        })
        instance.start()
      }

      parseFromToPair(str, { defaults } = { defaults: {} }) {
        if (!str) { return defaults }

        const [from, to] = str.split(',')
        return { from, to }
      }
    }
  )
}
